/*************************************************************************************
* site35th
*************************************************************************************/

$(function () {

    $('#js_floatingBanner_close').click (function () {
        $('.bl_floatingBanner').addClass("js_close");
      });
    
});



